export default __webpack_public_path__ + "static/media/a1-2-1.9f91df50.jpg";